import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { TabTypes } from '../../../Components/index';
import classes from '../create.css';

const Step2New = (props) => {
  const { roomType, setRoomType } = props;
  return (
    <Fragment>
      <p style={{ marginBottom: 10 }}>Sélectionnez un type d'espace de travail</p>
      <div className={classes.RadioButtons}>
        <TabTypes.RadioButtons onClick={setRoomType} checked={roomType} />
      </div>
    </Fragment>
  );
};

Step2New.propTypes = {
  roomType: PropTypes.string.isRequired,
  setRoomType: PropTypes.func.isRequired,
};

export default Step2New;



// WEBPACK FOOTER //
// ./src/Containers/Create/NewResource/Step2New.js